<template>
  <div class="myAddressBox">
    <!-- 标题box -->
    <div class="myAddressBox_title">{{ title }}</div>
    <!-- 新增按钮box -->
    <div class="myAddressBox_btnBox">
      <el-button type="primary" class="myAddressBox_btn" @click="showDialog()"
        >新增收货地址</el-button
      >
      <span>您已创建{{ shopAddress.length }}个收货地址，最多可创建20个</span>
    </div>
    <!-- 地址列表 -->
    <div
      class="myAddressBox_listBox"
      v-for="(item, index) in shopAddress"
      :key="index"
    >
      <div class="listBox_head">
        <span>{{ JSON.parse(item.address).label.split(" ")[0] }}</span>
        <i
          class="el-icon-close"
          style="cursor: pointer"
          @click="deleteItem(item.id)"
        ></i>
      </div>
      <div class="listBox_name">
        <span style="color: #777">收货人：</span
        >{{ JSON.parse(item.address).label.split(" ")[0] }}&nbsp;&nbsp;{{
          JSON.parse(item.address).label.split(" ")[1]
        }}
      </div>
      <div class="listBox_address">
        <div class="listBox_addressL">
          <span style="color: #777">收货地址：</span
          >{{
            JSON.parse(item.address).label.split(" ")[2] +
            JSON.parse(item.address).label.split(" ")[3]
          }}
        </div>
        <div class="listBox_addressR">
          <el-link
            type="primary"
            :underline="false"
            class="listBox_addressBtn"
            @click="setDefault(item)"
            :disabled="index == 0"
            >设为默认地址</el-link
          >
          <el-link
            type="primary"
            :underline="false"
            class="listBox_addressBtn"
            @click="editDialog(JSON.parse(item.address), item.id, index)"
            >编辑</el-link
          >
        </div>
      </div>
    </div>
    <!-- 无地址数据时的替代 -->
    <el-empty
      description="暂无数据"
      v-if="shopAddress.length == 0"
      style="background-color: #fff; margin-top: 20px"
    ></el-empty>
    <!-- 新增收货地址弹窗 -->
    <el-dialog
      title="新增收货地址"
      :visible.sync="dialogVisible"
      width="767px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="收货人：" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入收货人"
            style="width: 270px"
            @input="ruleForm.name = ruleForm.name.replace(/\s+/g, '')"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区：" prop="area">
          <area-select
            v-if="isShowArea"
            v-model="ruleForm.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item>
        <el-form-item label="详细地址：" prop="address">
          <el-input
            v-model="ruleForm.address"
            placeholder="请输入详细地址"
            style="width: 622px"
            @input="ruleForm.address = ruleForm.address.replace(/\s+/g, '')"
          ></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :span="5"
            ><el-form-item label="手机号码：" prop="phone">
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入手机号码"
              ></el-input> </el-form-item
          ></el-col>
          <!-- <el-col :span="1" style="text-align:center;margin-top: 60px"
            >或
          </el-col>
          <el-col :span="5"
            ><el-form-item label="固定电话：" prop="telephone">
              <el-input
                v-model="ruleForm.telephone"
                placeholder="请输入固定电话"
              ></el-input> </el-form-item
          ></el-col> -->
        </el-row>
        <el-checkbox v-model="isDefaultAdr">设为默认地址</el-checkbox>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改收货地址弹窗 -->
    <el-dialog
      title="编辑收货地址"
      :visible.sync="dialogVisible2"
      width="767px"
      :before-close="handleClose2"
    >
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="收货人：" prop="name">
          <el-input
            v-model="ruleForm2.name"
            placeholder="请输入收货人"
            style="width: 270px"
            @input="ruleForm2.name = ruleForm2.name.replace(/\s+/g, '')"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区：" prop="area">
          <area-select
            v-model="ruleForm2.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item>
        <el-form-item label="详细地址：" prop="address">
          <el-input
            v-model="ruleForm2.address"
            placeholder="请输入详细地址"
            style="width: 622px"
            @input="ruleForm2.address = ruleForm2.address.replace(/\s+/g, '')"
          ></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :span="5"
            ><el-form-item label="手机号码：" prop="phone">
              <el-input
                v-model="ruleForm2.phone"
                placeholder="请输入手机号码"
              ></el-input> </el-form-item
          ></el-col>
          <!-- <el-col :span="1" style="text-align:center;margin-top: 60px"
            >或
          </el-col>
          <el-col :span="5"
            ><el-form-item label="固定电话：" prop="telephone">
              <el-input
                v-model="ruleForm2.telephone"
                placeholder="请输入固定电话"
              ></el-input> </el-form-item
          ></el-col> -->
        </el-row>
        <el-checkbox v-model="isDefaultAdr2">设为默认地址</el-checkbox>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm2('ruleForm2')">取 消</el-button>
        <el-button type="primary" @click="submitForm2('ruleForm2')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { doGet, postAction, doPost } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      shopAddress: [], //收货地址列表
      isShowArea: true, //用于销毁省市区组件
      dialogVisible: false, //新增地址弹窗是否显示
      dialogVisible2: false, //修改地址弹窗是否显示

      ruleForm: {
        //新增地址表单
        name: "",
        area: [],
        address: "",
        phone: "",
        // telephone: ""
      },
      rules: {
        //新增地址表单验证
        name: [{ required: true, message: "请输入收货人", trigger: "blur" }],
        city: [{ required: true, message: "请选择所在市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        area: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        // telephone: [
        //   { required: true, message: "请输入固定电话", trigger: "blur" }
        // ]
      },
      isDefaultAdr: false, //新增地址时，是否为默认地址
      chooseItem: "", //点击修改地址时，选中的地址
      ruleForm2: {
        //修改地址表单
        name: "",
        area: [],
        address: "",
        phone: "",
        // telephone: ""
      },
      rules2: {
        //修改地址表单验证
        name: [{ required: true, message: "请输入收货人", trigger: "blur" }],
        city: [{ required: true, message: "请选择所在市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        area: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        // telephone: [
        //   { required: true, message: "请输入固定电话", trigger: "blur" }
        // ]
      },
      isDefaultAdr2: false, //修改地址时，是否为默认地址
      editIndex: "", //被修改的地址的索引
      editId: "", //被修改的地址的id
    };
  },
  mounted() {
    this.getAddressList();
    // this.deleteItem(9);
  },
  methods: {
    /**
     * 获取地址列表
     */
    getAddressList() {
      var that = this;
      doGet(
        httpConfig.myAddress.getAddressUrl,
        {  },
        function (res) {
          if (res.flag) {
            that.shopAddress = res.data;
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 设为默认
     */
    setDefault(item) {
      var that = this;
      doPost(
        httpConfig.myAddress.saveAddressUrl,
        {
          address: item.address,
          isDefault: 1,
          id: item.id,
        },
        function (res) {
          if (res.flag) {
            that.getAddressList();
            that.$message({
              message: "设为默认地址成功",
              type: "success",
            });
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 删除地址
     */
    deleteItem(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          doGet(
            httpConfig.myAddress.deleteAddressUrl,
            {
              id,
            },
            function (res) {
              if (res.flag) {
                that.getAddressList();
                that.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
        })
        .catch((_) => {});
    },
    /**
     * 关闭新增收货地址弹窗
     */
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("ruleForm");
          done();
        })
        .catch((_) => {});
    },
    /**
     * 确认添加收货地址
     */
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var area =
            Object.values(this.ruleForm.area[0])[0] +
            Object.values(this.ruleForm.area[1])[0] +
            Object.values(this.ruleForm.area[2])[0] +
            Object.values(this.ruleForm.area[3])[0];
          // var areaCode = [
          //   Object.keys(this.ruleForm.area[0])[0],
          //   Object.keys(this.ruleForm.area[1])[0],
          //   Object.keys(this.ruleForm.area[2])[0],
          //   Object.keys(this.ruleForm.area[3])[0]
          // ];
          var shopAddress = JSON.parse(JSON.stringify(this.ruleForm));
          delete shopAddress.area;
          delete shopAddress.address;
          delete shopAddress.name;
          delete shopAddress.phone;
          // shopAddress["area"] = area;
          shopAddress["all"] = this.ruleForm.area;
          // shopAddress["areaCode"] = areaCode;
          shopAddress["label"] =
            this.ruleForm.name.trim() +
            " " +
            this.ruleForm.phone.trim() +
            " " +
            area +
            " " +
            this.ruleForm.address.trim();

          doPost(
            httpConfig.myAddress.saveAddressUrl,
            {
              address: JSON.stringify(shopAddress),
              isDefault: that.isDefaultAdr ? 1 : 0,
            },
            function (res) {
              if (res.flag) {
                that.resetForm("ruleForm");
                that.getAddressList();
                that.$message({
                  message: "新增成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
        } else {
          return false;
        }
      });
    },
    /**
     * 取消添加收货地址
     */
    resetForm(formName) {
      this.isDefaultAdr = false;
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    /**
     * 点击新增收货地址
     */
    showDialog() {
      if (this.shopAddress.length > 19) {
        this.$message({
          message: "最多可以添加20条地址，如需新增，请先删除一条",
          type: "warning",
        });
        return;
      }
      this.isShowArea = false;
      var t = setTimeout(() => {
        this.isShowArea = true;
      }, 0);
      this.dialogVisible = true;
    },
    /**
     * 编辑收货地址
     */
    editDialog(item, id, index) {
      var areaCode = [
        Object.keys(item.all[0])[0],
        Object.keys(item.all[1])[0],
        Object.keys(item.all[2])[0],
        Object.keys(item.all[3])[0],
      ];
      this.ruleForm2 = {
        name: item.label.split(" ")[0],
        area: areaCode,
        address: item.label.split(" ")[3],
        phone: item.label.split(" ")[1],
        // telephone: item.telephone
      };
      this.chooseItem = item.all;
      this.dialogVisible2 = true;
      this.editIndex = index;
      this.editId = id;
      if (index == 0) {
        this.isDefaultAdr2 = true;
      }
    },
    /**
     * 关闭编辑收货地址弹窗
     */
    handleClose2(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm2("ruleForm2");
          done();
        })
        .catch((_) => {});
    },
    /**
     * 确认编辑收货地址
     */
    submitForm2(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (typeof this.ruleForm2.area[0] == "string") {
            this.ruleForm2.area = this.chooseItem;
          }
          var area =
            Object.values(this.ruleForm2.area[0])[0] +
            Object.values(this.ruleForm2.area[1])[0] +
            Object.values(this.ruleForm2.area[2])[0] +
            Object.values(this.ruleForm2.area[3])[0];
          // var areaCode = [
          //   Object.keys(this.ruleForm2.area[0])[0],
          //   Object.keys(this.ruleForm2.area[1])[0],
          //   Object.keys(this.ruleForm2.area[2])[0],
          //   Object.keys(this.ruleForm2.area[3])[0]
          // ];
          var shopAddress = JSON.parse(JSON.stringify(this.ruleForm2));
          delete shopAddress.area;
          delete shopAddress.address;
          delete shopAddress.name;
          delete shopAddress.phone;
          // shopAddress["area"] = area;
          shopAddress["all"] = this.ruleForm2.area;
          // shopAddress["areaCode"] = areaCode;
          shopAddress["label"] =
            this.ruleForm2.name +
            " " +
            this.ruleForm2.phone +
            " " +
            area +
            " " +
            this.ruleForm2.address;
          doPost(
            httpConfig.myAddress.saveAddressUrl,
            {
              address: JSON.stringify(shopAddress),
              isDefault: that.isDefaultAdr2 ? 1 : 0,
              id: that.editId,
            },
            function (res) {
              if (res.flag) {
                that.getAddressList();
                that.resetForm2("ruleForm2");
                that.$message({
                  message: "编辑成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
        } else {
          return false;
        }
      });
    },
    /**
     * 取消编辑收货地址
     */
    resetForm2(formName) {
      this.isDefaultAdr2 = false;
      this.$refs[formName].resetFields();
      this.dialogVisible2 = false;
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/myAddress";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/myAddress.vue